module.exports = __webpack_public_path__ + "static/media/S (118).322c511f.jpg";